<div>
  <a *ngIf="dropdownType === DropdownType.Default"
     nz-dropdown
     [nzTrigger]="triggerType"
     [nzDropdownMenu]="menu"
     [nzPlacement]="placement">
    <ng-container *ngIf="labelMode === DropdownMenuLabelMode.StaticLabel">
      <span *ngIf="label"
            class="dropdown-text">{{ label }}</span>
      <rappider-icon *ngIf="icon?.name"
                     [name]="icon.name"
                     [color]="icon.color"
                     [theme]="icon.theme"
                     [type]="icon.type"
                     [size]="icon.size"></rappider-icon>
    </ng-container>
    <ng-container *ngIf="labelMode === DropdownMenuLabelMode.SelectedValue">
      <rappider-icon *ngIf="findSelectedItem()?.icon?.name"
                     [name]="findSelectedItem().icon.name"
                     [color]="findSelectedItem().icon.color"
                     [theme]="findSelectedItem().icon.theme"
                     [type]="findSelectedItem().icon.type"
                     [size]="findSelectedItem().icon.size"></rappider-icon>
      <span *ngIf="findSelectedItem()"
            class="label">{{ findSelectedItem().label }}</span>
      <rappider-icon *ngIf="icon?.name"
                     [name]="icon.name"
                     [color]="icon.color"
                     [theme]="icon.theme"
                     [type]="icon.type"
                     [size]="icon.size"></rappider-icon>
    </ng-container>
  </a>

  <button *ngIf="dropdownType === DropdownType.Button"
          nz-button
          nz-dropdown
          class="button-dropdown"
          [nzTrigger]="triggerType"
          [nzDropdownMenu]="menu"
          [nzPlacement]="placement">
    <ng-container *ngIf="labelMode === DropdownMenuLabelMode.StaticLabel">
      <span *ngIf="label">{{ label }}</span>
      <rappider-icon *ngIf="icon?.name"
                     [name]="icon.name"
                     [color]="icon.color"
                     [theme]="icon.theme"
                     [type]="icon.type"
                     [size]="icon.size"></rappider-icon>
    </ng-container>
    <ng-container *ngIf="labelMode === DropdownMenuLabelMode.SelectedValue">
      <rappider-icon *ngIf="findSelectedItem()?.icon?.name"
                     [name]="findSelectedItem().icon.name"
                     [color]="findSelectedItem().icon.color"
                     [theme]="findSelectedItem().icon.theme"
                     [type]="findSelectedItem().icon.type"
                     [size]="findSelectedItem().icon.size"></rappider-icon>
      <span *ngIf="findSelectedItem()"
            class="label">{{ findSelectedItem().label }}</span>
      <rappider-icon *ngIf="icon?.name"
                     [name]="icon.name"
                     [color]="icon.color"
                     [theme]="icon.theme"
                     [type]="icon.type"
                     [size]="icon.size"></rappider-icon>
    </ng-container>
  </button>

  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <ng-container *ngTemplateOutlet="recursiveMenuList; context:{ $implicit: items }"></ng-container>
      <ng-template #recursiveMenuList
                   let-menus>
        <ng-container *ngFor="let menu of menus">
          <div *ngIf="menu.visible !== false">
            <li *ngIf="menu.items?.length; else menuItem"
                nz-submenu
                class="menu-item"
                [nzTitle]="menu.label | translate"
                (click)="onMenuItemClick($event, menu)">
              <div>
                <rappider-icon *ngIf="menu.icon?.name"
                               [name]="menu.icon.name"
                               [color]="menu.icon.color"
                               [theme]="menu.icon.theme"
                               [type]="menu.icon.type"
                               [size]="menu.icon.size"></rappider-icon>
                <span>{{ menu.label | translate }}</span>
              </div>
              <ul>
                <ng-container *ngTemplateOutlet="recursiveMenuList; context:{ $implicit: menu.items }"></ng-container>
              </ul>
            </li>

            <ng-template #menuItem>
              <ng-container *ngIf="menu.popconfirmTitle && !menu.disabled">
                <li nz-menu-item
                    class="menu-item"
                    [ngClass]="{'menu-item-borderless': borderless}"
                    nz-popconfirm
                    [nzPopconfirmTitle]="menu.popconfirmTitle | translate"
                    [nzOkText]="menu.label| translate"
                    [nzOkDanger]="menu.popconfirmOkDanger"
                    (nzOnConfirm)="onMenuItemClick($event, menu)">
                  <div class="menu-item-content">
                    <rappider-icon *ngIf="menu.icon?.name"
                                   [name]="menu.icon.name"
                                   [color]="menu.icon.color"
                                   [theme]="menu.icon.theme"
                                   [type]="menu.icon.type"
                                   [size]="menu.icon.size"></rappider-icon>
                    <span>{{ menu.label | translate }}</span>
                  </div>
                </li>
              </ng-container>

              <ng-container *ngIf="menu.disabled">
                <li nz-menu-item
                    class="menu-item ant-dropdown-menu-item-disabled disabled-menu-item"
                    disabled
                    nz-tooltip
                    [nzTooltipTitle]="menu.tooltip"
                    [nzTooltipPlacement]="menu.tooltipPlacement"
                    style="background-color: #f5f5f5 !important; border-color: #d9d9d9 !important; color: rgba(0, 0, 0, 0.25) !important; opacity: 0.65 !important; cursor: not-allowed !important;"
                    [ngClass]="{'menu-item-borderless': borderless}"
                    (click)="$event.preventDefault(); $event.stopPropagation();">
                  <div class="menu-item-content">
                    <rappider-icon *ngIf="menu.icon?.name"
                                   [name]="menu.icon.name"
                                   [style.color]="'rgba(0, 0, 0, 0.25)'"
                                   [theme]="menu.icon.theme"
                                   [type]="menu.icon.type"
                                   [size]="menu.icon.size"></rappider-icon>
                    <span style="color: rgba(0, 0, 0, 0.25) !important;">{{ menu.label | translate }}</span>
                  </div>
                </li>
              </ng-container>

              <ng-container *ngIf="!menu.popconfirmTitle && !menu.disabled">
                <li nz-menu-item
                    class="menu-item"
                    [ngClass]="{'menu-item-borderless': borderless}"
                    (click)="onMenuItemClick($event, menu)">
                  <div class="menu-item-content">
                    <rappider-icon *ngIf="menu.icon?.name"
                                   [name]="menu.icon.name"
                                   [color]="menu.icon.color"
                                   [theme]="menu.icon.theme"
                                   [type]="menu.icon.type"
                                   [size]="menu.icon.size"></rappider-icon>
                    <span>{{ menu.label | translate }}</span>
                  </div>
                </li>
              </ng-container>
            </ng-template>
          </div>
        </ng-container>
      </ng-template>
    </ul>
  </nz-dropdown-menu>
</div>
